import { CLASSES as _ } from "../Types.js";
import { Attribute as a } from "../Attribute.js";
import { AttributeDefinitions as A } from "../AttributeDefinitions.js";
import { DockLocation as l } from "../DockLocation.js";
import { DropInfo as u } from "../DropInfo.js";
import { Orientation as T } from "../Orientation.js";
import { Rect as g } from "../Rect.js";
import { Node as E } from "./Node.js";
import { SplitterNode as z } from "./SplitterNode.js";
import { TabNode as R } from "./TabNode.js";
import { adjustSelectedIndex as p } from "./Utils.js";
class c extends E {
  static TYPE = "border";
  /** @internal */
  static _fromJson(t, r) {
    const e = l.getByName(t.location), s = new c(e, t, r);
    return t.children && (s._children = t.children.map((o) => {
      const i = R._fromJson(o, r);
      return i._setParent(s), i;
    })), s;
  }
  /** @internal */
  static _attributeDefinitions = c._createAttributeDefinitions();
  /** @internal */
  static _createAttributeDefinitions() {
    const t = new A();
    return t.add("type", c.TYPE, !0).setType(a.STRING).setFixed(), t.add("selected", -1).setType(a.NUMBER), t.add("show", !0).setType(a.BOOLEAN), t.add("config", void 0).setType("any"), t.addInherited("barSize", "borderBarSize").setType(a.NUMBER), t.addInherited("enableDrop", "borderEnableDrop").setType(a.BOOLEAN), t.addInherited("className", "borderClassName").setType(a.STRING), t.addInherited("autoSelectTabWhenOpen", "borderAutoSelectTabWhenOpen").setType(a.BOOLEAN), t.addInherited("autoSelectTabWhenClosed", "borderAutoSelectTabWhenClosed").setType(a.BOOLEAN), t.addInherited("size", "borderSize").setType(a.NUMBER), t.addInherited("minSize", "borderMinSize").setType(a.NUMBER), t.addInherited("enableAutoHide", "borderEnableAutoHide").setType(a.BOOLEAN), t;
  }
  /** @internal */
  _contentRect;
  /** @internal */
  _tabHeaderRect;
  /** @internal */
  _location;
  /** @internal */
  _drawChildren;
  /** @internal */
  _adjustedSize = 0;
  /** @internal */
  _calculatedBorderBarSize = 0;
  /** @internal */
  constructor(t, r, e) {
    super(e), this._location = t, this._drawChildren = [], this._attributes.id = `border_${t.getName()}`, c._attributeDefinitions.fromJson(r, this._attributes), e._addNode(this);
  }
  getLocation() {
    return this._location;
  }
  getTabHeaderRect() {
    return this._tabHeaderRect;
  }
  getRect() {
    return this._tabHeaderRect;
  }
  getContentRect() {
    return this._contentRect;
  }
  isEnableDrop() {
    return this._getAttr("enableDrop");
  }
  isAutoSelectTab(t) {
    return t == null && (t = this.getSelected() !== -1), t ? this._getAttr("autoSelectTabWhenOpen") : this._getAttr("autoSelectTabWhenClosed");
  }
  getClassName() {
    return this._getAttr("className");
  }
  /** @internal */
  calcBorderBarSize(t) {
    const r = this._getAttr("barSize");
    r !== 0 ? this._calculatedBorderBarSize = r : this._calculatedBorderBarSize = t.borderBarSize;
  }
  getBorderBarSize() {
    return this._calculatedBorderBarSize;
  }
  getSize() {
    const t = this._getAttr("size"), r = this.getSelected();
    if (r === -1)
      return t;
    {
      const e = this._children[r], s = this._location._orientation.equlas(T.HORZ) ? e._getAttr("borderWidth") : e._getAttr("borderHeight");
      return s === -1 ? t : s;
    }
  }
  getMinSize() {
    return this._getAttr("minSize");
  }
  getName() {
    return this._getAttr("name");
  }
  getSelected() {
    return this._attributes.selected;
  }
  getSelectedNode() {
    if (this.getSelected() !== -1)
      return this._children[this.getSelected()];
  }
  getOrientation() {
    return this._location.getOrientation();
  }
  /**
     * Returns the config attribute that can be used to store node specific data that
     * WILL be saved to the json. The config attribute should be changed via the action Actions.updateNodeAttributes rather
     * than directly, for example:
     * this.state.model.doAction(
     *   FlexLayout.Actions.updateNodeAttributes(node.getId(), {config:myConfigObject}));
     */
  getConfig() {
    return this._attributes.config;
  }
  isMaximized() {
    return !1;
  }
  isShowing() {
    return this._attributes.show ? !(this._model._getShowHiddenBorder() !== this._location && this.isAutoHide() && this._children.length === 0) : !1;
  }
  isAutoHide() {
    return this._getAttr("enableAutoHide");
  }
  /** @internal */
  _setSelected(t) {
    this._attributes.selected = t;
  }
  /** @internal */
  _setSize(t) {
    const r = this.getSelected();
    if (r === -1)
      this._attributes.size = t;
    else {
      const e = this._children[r];
      (this._location._orientation.equlas(T.HORZ) ? e._getAttr("borderWidth") : e._getAttr("borderHeight")) === -1 ? this._attributes.size = t : this._location._orientation.equlas(T.HORZ) ? e._setBorderWidth(t) : e._setBorderHeight(t);
    }
  }
  /** @internal */
  _updateAttrs(t) {
    c._attributeDefinitions.update(t, this._attributes);
  }
  /** @internal */
  _getDrawChildren() {
    return this._drawChildren;
  }
  /** @internal */
  _setAdjustedSize(t) {
    this._adjustedSize = t;
  }
  /** @internal */
  _getAdjustedSize() {
    return this._adjustedSize;
  }
  /** @internal */
  _layoutBorderOuter(t, r) {
    this.calcBorderBarSize(r);
    const e = this._location.split(t, this.getBorderBarSize());
    return this._tabHeaderRect = e.start, e.end;
  }
  /** @internal */
  _layoutBorderInner(t, r) {
    this._drawChildren = [];
    const e = this._location, s = e.split(t, this._adjustedSize + this._model.getSplitterSize()), o = e.reflect().split(s.start, this._model.getSplitterSize());
    this._contentRect = o.end;
    for (let i = 0; i < this._children.length; i++) {
      const n = this._children[i];
      n._layout(this._contentRect, r), n._setVisible(i === this.getSelected()), this._drawChildren.push(n);
    }
    if (this.getSelected() === -1)
      return t;
    {
      const i = new z(this._model);
      return i._setParent(this), i._setRect(o.start), this._drawChildren.push(i), s.end;
    }
  }
  /** @internal */
  _remove(t) {
    const r = this._removeChild(t);
    this.getSelected() !== -1 && p(this, r);
  }
  /** @internal */
  canDrop(t, r, e) {
    if (t.getType() !== R.TYPE)
      return;
    let s;
    const o = l.CENTER;
    if (this._tabHeaderRect.contains(r, e)) {
      if (this._location._orientation.equlas(T.VERT))
        if (this._children.length > 0) {
          let i = this._children[0], n = i.getTabRect();
          const b = n.y, f = n.height;
          let S = this._tabHeaderRect.x, d = 0;
          for (let h = 0; h < this._children.length; h++) {
            if (i = this._children[h], n = i.getTabRect(), d = n.x + n.width / 2, r >= S && r < d) {
              const m = new g(n.x - 2, b, 3, f);
              s = new u(this, m, o, h, _.FLEXLAYOUT__OUTLINE_RECT);
              break;
            }
            S = d;
          }
          if (s == null) {
            const h = new g(n.getRight() - 2, b, 3, f);
            s = new u(this, h, o, this._children.length, _.FLEXLAYOUT__OUTLINE_RECT);
          }
        } else {
          const i = new g(this._tabHeaderRect.x + 1, this._tabHeaderRect.y + 2, 3, 18);
          s = new u(this, i, o, 0, _.FLEXLAYOUT__OUTLINE_RECT);
        }
      else if (this._children.length > 0) {
        let i = this._children[0], n = i.getTabRect();
        const b = n.x, f = n.width;
        let S = this._tabHeaderRect.y, d = 0;
        for (let h = 0; h < this._children.length; h++) {
          if (i = this._children[h], n = i.getTabRect(), d = n.y + n.height / 2, e >= S && e < d) {
            const m = new g(b, n.y - 2, f, 3);
            s = new u(this, m, o, h, _.FLEXLAYOUT__OUTLINE_RECT);
            break;
          }
          S = d;
        }
        if (s == null) {
          const h = new g(b, n.getBottom() - 2, f, 3);
          s = new u(this, h, o, this._children.length, _.FLEXLAYOUT__OUTLINE_RECT);
        }
      } else {
        const i = new g(this._tabHeaderRect.x + 2, this._tabHeaderRect.y + 1, 18, 3);
        s = new u(this, i, o, 0, _.FLEXLAYOUT__OUTLINE_RECT);
      }
      if (!t._canDockInto(t, s))
        return;
    } else if (this.getSelected() !== -1 && this._contentRect.contains(r, e)) {
      const i = this._contentRect;
      if (s = new u(this, i, o, -1, _.FLEXLAYOUT__OUTLINE_RECT), !t._canDockInto(t, s))
        return;
    }
    return s;
  }
  /** @internal */
  drop(t, r, e, s) {
    let o = 0;
    const i = t.getParent();
    i !== void 0 && (o = i._removeChild(t), i !== this && i instanceof c && i.getSelected() === o ? i._setSelected(-1) : p(i, o)), t.getType() === R.TYPE && i === this && o < e && e > 0 && e--;
    let n = e;
    n === -1 && (n = this._children.length), t.getType() === R.TYPE && this._addChild(t, n), (s || s !== !1 && this.isAutoSelectTab()) && this._setSelected(n), this._model._tidy();
  }
  toJson() {
    const t = {};
    return c._attributeDefinitions.toJson(t, this._attributes), t.location = this._location.getName(), t.children = this._children.map((r) => r.toJson()), t;
  }
  /** @internal */
  _getSplitterBounds(t, r = !1) {
    const e = [0, 0], s = r ? this.getMinSize() : 0, o = this._model._getOuterInnerRects().outer, i = this._model._getOuterInnerRects().inner, n = this._model.getRoot();
    return this._location.equals(l.TOP) ? (e[0] = o.y + s, e[1] = Math.max(e[0], i.getBottom() - t.getHeight() - n.getMinHeight())) : this._location.equals(l.LEFT) ? (e[0] = o.x + s, e[1] = Math.max(e[0], i.getRight() - t.getWidth() - n.getMinWidth())) : this._location.equals(l.BOTTOM) ? (e[1] = o.getBottom() - t.getHeight() - s, e[0] = Math.min(e[1], i.y + n.getMinHeight())) : this._location.equals(l.RIGHT) && (e[1] = o.getRight() - t.getWidth() - s, e[0] = Math.min(e[1], i.x + n.getMinWidth())), e;
  }
  /** @internal */
  _calculateSplit(t, r) {
    const e = this._getSplitterBounds(t);
    return this._location.equals(l.BOTTOM) || this._location.equals(l.RIGHT) ? Math.max(0, e[1] - r) : Math.max(0, r - e[0]);
  }
  /** @internal */
  _getAttributeDefinitions() {
    return c._attributeDefinitions;
  }
  /** @internal */
  static getAttributeDefinitions() {
    return c._attributeDefinitions;
  }
}
export {
  c as BorderNode
};
//# sourceMappingURL=BorderNode.js.map
